export const AppConstants = {
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
  MAX_FILE_SIZE_MB: 50, // for UI messages if needed
};